import { esusApi } from "@/services/api";

export type ResumeIndicatorB4Params = {
	uf: string;
	ibgeCode: string;
	quarter: string;
	year: number;
	month: number;
	ine?: string;
};

export class ResumeIndicatorB4Data {
	totalCitizensFinishedLinked: number = 0;
	totalCitizensFinished: number = 0;
	totalCitizens: number = 0;
	totalCitizensNotLinked: number = 0;
}

export async function getResumeIndicatorB4({ uf, ibgeCode, ...params }: ResumeIndicatorB4Params) {
	const response = await esusApi.get<ResumeIndicatorB4Data>(
		`/uf/${uf}/city/${ibgeCode}/indicator/esb/b4/resume`,
		params
	);
	return response.data || new ResumeIndicatorB4Data();
}
